import React from "react";
import "./UserStatCard.css";

export default function UserStatCard({ label, value, Icon, iconColor = "#6366f1" }) {
  return (
    <div className="user-stat-card">
      <div className="user-stat-card-icon" style={{ color: iconColor }}>
        {Icon && <Icon size={28} />}
      </div>
      <div className="user-stat-card-content">
        <div className="user-stat-card-label">{label}</div>
        <div className="user-stat-card-value">{value}</div>
      </div>
    </div>
  );
}
